/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import systems.frictionless.impulse.browser.style.AppStyleSheet

@Composable
fun HiImImpulse() {
    Img(attrs = {
        classes(AppStyleSheet.logo)
    }, src = "/asset/img/impulse-logo.svg")

    H1(attrs = {
        classes(AppStyleSheet.headerWithNote)
    }) {
        Text("Hi. I'm Impulse®")
    }
    P(attrs = {
        classes(AppStyleSheet.noteBelowHeader)
    }) {
        Text("by ")
        A(href = "https://www.frictionless.systems/", attrs = {
            target(ATarget.Blank)
        }) {
            Text("Frictionless Systems")
        }
    }

    P {
        B {
            Text("I'm here to help you to ")
        }
        Text("discover")
        Br { }
        Text("Your blockers and promoters ")
        B {
            Text("of flow")
        }
        Text(".")
    }
}
